var messageTexts = {
  'sv-SE': {
    expandableAriaLabel: 'Visa mer information'
  },
  'nb-NO': {
    expandableAriaLabel: 'Vis mer informasjon'
  },
  'da-DK': {
    expandableAriaLabel: 'Vis mere information'
  },
  'fi-FI': {
    expandableAriaLabel: 'Näytä lisätietoja'
  },
  en: {
    expandableAriaLabel: 'Show more information'
  }
};
var texts = messageTexts;

export { texts as default };
//# sourceMappingURL=Message.texts.js.map
